function topic_alarm(default_topic = '#t_weather', default_open = '#collapse1'){
	// table create
	$("#home4 .card-body").html(
		slider_card_component_create({
			"cardhead": "監控資料追蹤",
			"cardbody": data_source_table_html("監測示警")
		}, false) +
		'<div class="accordion pt-2 pb-4" id="accordionExample">' +
			`<div class="card">
				<div class="p-2 bg-light border-bottom" id="t_weather" style="cursor:pointer">
					<div class="font-weight-bold" data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
						<img class="mr-2 mb-2" src="topic_icon/weather_alarm.png" width="24px" alt="">
						<span style="font-size: 24px">天氣類示警</span>
						<i id="weather-chevron" class="fas fa-angle-up fa-lg" 
							style="float:right; cursor:pointer; margin-top:12px"></i>
					</div>
				</div>
				<div id="collapse1" class="collapse" aria-labelledby="t_weather" data-parent="#accordionExample">
					<div id="weather-cardbody"></div>
				</div>
			</div>` +
			`<div class="card">
				<div class="p-2 bg-light border-bottom" id="t_flood" style="cursor:pointer">
					<div class="font-weight-bold" data-toggle="collapse" data-target="#collapse2" aria-expanded="true" aria-controls="collapse2">
						<img class="mr-2 mb-2" src="topic_icon/flood_alarm.png" width="24px" alt="">
						<span style="font-size: 24px">淹水類示警</span>
						<i id="flood-chevron" class="fas fa-angle-up fa-lg" 
							style="float:right; cursor:pointer; margin-top:12px"></i>
					</div>
				</div>
				<div id="collapse2" class="collapse p-2" aria-labelledby="t_flood" data-parent="#accordionExample">
					<div id="flood-cardbody"></div>
				</div>
			</div>` +
			`<div class="card">
				<div class="p-2 bg-light border-bottom" id="t_hillslope" style="cursor:pointer">
					<div class="font-weight-bold" data-toggle="collapse" data-target="#collapse3" aria-expanded="true" aria-controls="collapse3">
						<img class="mr-2 mb-2" src="topic_icon/hillslope_alarm.png" width="24px" alt="">
						<span style="font-size: 24px">坡地類示警</span>
						<i id="hillslope-chevron" class="fas fa-angle-up fa-lg" 
							style="float:right; cursor:pointer; margin-top:12px"></i>
					</div>
				</div>
				<div id="collapse3" class="collapse p-2" aria-labelledby="t_hillslope" data-parent="#accordionExample">
					<div id="hillslope-cardbody"></div>
				</div>
			</div>` +
		'</div>'
	);

	$("#t_weather").click(function(){
		if ($("#collapse1").hasClass("show")) {
			$("#weather-chevron").css('transform', 'rotate(0deg)')
		} else {
			loader_asynchronous(function(){
				layer_table_redraw();
				$("#map_clear").click();
				backgroud_layer_control("雨量站");
				backgroud_layer_control("閃電觀測");
				backgroud_layer_control("雷達強回波值");
				$("#base_layer .leaflet-layerstree-children").find("input").eq(4).click();
				topic_weather_alarm();
				emisEventPointOpenInTopic()
			})
			$("#weather-chevron").css('transform', 'rotate(180deg)')
			$("#flood-chevron").css('transform', 'rotate(0deg)')
			$("#hillslope-chevron").css('transform', 'rotate(0deg)')
		}
	})

	$("#t_flood").click(function(){
		if ($("#collapse2").hasClass("show")) {
			$("#flood-chevron").css('transform', 'rotate(0deg)')
		} else {
			loader_asynchronous(function(){
				layer_table_redraw();
				$("#map_clear").click();
				backgroud_layer_control("淹水感知器");
				backgroud_layer_control("水利署水位");
				backgroud_layer_control("水利局水位");
				backgroud_layer_control("抽水站");
				backgroud_layer_control("移動抽水機");
				backgroud_layer_control("橫移門");
				backgroud_layer_control("重要水庫");
				backgroud_layer_control("員山子分洪");
				$("#base_layer .leaflet-layerstree-children").find("input").eq(3).click();
				topic_flood_alarm();
				emisEventPointOpenInTopic()
			})
			$("#weather-chevron").css('transform', 'rotate(0deg)')
			$("#flood-chevron").css('transform', 'rotate(180deg)')
			$("#hillslope-chevron").css('transform', 'rotate(0deg)')
		}
	})

	$("#t_hillslope").click(function(){
		if ($("#collapse3").hasClass("show")) {
			$("#hillslope-chevron").css('transform', 'rotate(0deg)')
		} else {
			loader_asynchronous(function(){
				layer_table_redraw();
				$("#map_clear").click();
				backgroud_layer_control("土石流潛勢溪流");
				backgroud_layer_control("土石流衝擊範圍");
				backgroud_layer_control("九份地滑監測");
				$("#base_layer .leaflet-layerstree-children").find("input").eq(4).click();
				topic_hillslope_alarm();
				emisEventPointOpenInTopic()
			})
			$("#weather-chevron").css('transform', 'rotate(0deg)')
			$("#flood-chevron").css('transform', 'rotate(0deg)')
			$("#hillslope-chevron").css('transform', 'rotate(180deg)')
		}
	})

	$(default_topic).click()
	$(default_open).addClass('show')
}
